import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import RocketImage from '../../assets/home/Rocket.webp';
import { t } from '../../i18n/i18n';
import { CREATE_EVALUATION } from '../../constants/routes';
import './EmptyEvaluationsState.scss';

const EmptyEvaluationsState = () => {
  const history = useHistory();

  const handleCreateEvaluation = () => {
    history.push(CREATE_EVALUATION);
  };

  return (
    <Card className="empty-evaluations-card" bordered={false}>
      <div className="empty-evaluations-content">
        <img src={RocketImage} alt="Rocket" className="rocket-image" />
        <h3 className="empty-title">{t('EMPTY_EVALUATIONS_TITLE')}</h3>
        <p className="empty-subtitle">{t('EMPTY_EVALUATIONS_SUBTITLE')}</p>
        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          onClick={handleCreateEvaluation}
          className="create-button"
        >
          {t('HOME_EMPTY_SEARCH_CREATE_EVALUATION')}
        </Button>
      </div>
    </Card>
  );
};

export default EmptyEvaluationsState;
